import { render, staticRenderFns } from "./VdmListView.vue?vue&type=template&id=47b46fe8&scoped=true"
import script from "./VdmListView.vue?vue&type=script&lang=js"
export * from "./VdmListView.vue?vue&type=script&lang=js"
import style0 from "./VdmListView.vue?vue&type=style&index=0&id=47b46fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b46fe8",
  null
  
)

export default component.exports